export default "__VITE_ASSET__R_JHW72x__"